import * as ambassadorWixEventsGuestsV1Guest from './events-guests-v1-guest-guests.http.js';
import * as ambassadorWixEventsGuestsV1GuestTypes from './events-guests-v1-guest-guests.types.js';
import * as ambassadorWixEventsGuestsV1GuestUniversalTypes from './events-guests-v1-guest-guests.universal.js';

export type __PublicMethodMetaInfo<
  K = string,
  M = unknown,
  T = unknown,
  S = unknown,
  Q = unknown,
  R = unknown
> = {
  getUrl: (context: any) => string;
  httpMethod: K;
  path: string;
  pathParams: M;
  __requestType: T;
  __originalRequestType: S;
  __responseType: Q;
  __originalResponseType: R;
};

export function queryGuests(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixEventsGuestsV1GuestUniversalTypes.QueryEventGuestsRequest,
  ambassadorWixEventsGuestsV1GuestTypes.QueryEventGuestsRequest,
  ambassadorWixEventsGuestsV1GuestUniversalTypes.QueryEventGuestsResponse,
  ambassadorWixEventsGuestsV1GuestTypes.QueryEventGuestsResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixEventsGuestsV1Guest.queryEventGuests(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v2/guests/query',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export {
  EventGuest as EventGuestOriginal,
  TicketDetails as TicketDetailsOriginal,
  TicketGuestDetails as TicketGuestDetailsOriginal,
  OnlineConferencingLogin as OnlineConferencingLoginOriginal,
  GuestDetails as GuestDetailsOriginal,
  FormResponse as FormResponseOriginal,
  InputValue as InputValueOriginal,
  FormattedAddress as FormattedAddressOriginal,
  Address as AddressOriginal,
  AddressStreetOneOf as AddressStreetOneOfOriginal,
  StreetAddress as StreetAddressOriginal,
  AddressLocation as AddressLocationOriginal,
  Subdivision as SubdivisionOriginal,
  SubdivisionType as SubdivisionTypeOriginal,
  SubdivisionTypeWithLiterals as SubdivisionTypeWithLiteralsOriginal,
  StandardDetails as StandardDetailsOriginal,
  FormSubmission as FormSubmissionOriginal,
  AttendanceStatus as AttendanceStatusOriginal,
  AttendanceStatusWithLiterals as AttendanceStatusWithLiteralsOriginal,
  GuestType as GuestTypeOriginal,
  GuestTypeWithLiterals as GuestTypeWithLiteralsOriginal,
  AdditionalDetails as AdditionalDetailsOriginal,
  RsvpStatus as RsvpStatusOriginal,
  RsvpStatusWithLiterals as RsvpStatusWithLiteralsOriginal,
  OrderStatus as OrderStatusOriginal,
  OrderStatusWithLiterals as OrderStatusWithLiteralsOriginal,
  GuestCountUpdated as GuestCountUpdatedOriginal,
  GuestCountUpdate as GuestCountUpdateOriginal,
  MemberEventStatusUpdated as MemberEventStatusUpdatedOriginal,
  MemberEventStatusUpdatedEventType as MemberEventStatusUpdatedEventTypeOriginal,
  MemberEventStatusUpdatedEventTypeWithLiterals as MemberEventStatusUpdatedEventTypeWithLiteralsOriginal,
  ContactEventStatusUpdated as ContactEventStatusUpdatedOriginal,
  EventType as EventTypeOriginal,
  EventTypeWithLiterals as EventTypeWithLiteralsOriginal,
  GuestCheckedIn as GuestCheckedInOriginal,
  EventDetails as EventDetailsOriginal,
  Location as LocationOriginal,
  LocationType as LocationTypeOriginal,
  LocationTypeWithLiterals as LocationTypeWithLiteralsOriginal,
  CommonAddress as CommonAddressOriginal,
  CommonAddressStreetOneOf as CommonAddressStreetOneOfOriginal,
  CommonStreetAddress as CommonStreetAddressOriginal,
  CommonAddressLocation as CommonAddressLocationOriginal,
  CommonSubdivision as CommonSubdivisionOriginal,
  SubdivisionSubdivisionType as SubdivisionSubdivisionTypeOriginal,
  SubdivisionSubdivisionTypeWithLiterals as SubdivisionSubdivisionTypeWithLiteralsOriginal,
  DateAndTimeSettings as DateAndTimeSettingsOriginal,
  RecurrenceStatusStatus as RecurrenceStatusStatusOriginal,
  RecurrenceStatusStatusWithLiterals as RecurrenceStatusStatusWithLiteralsOriginal,
  Recurrences as RecurrencesOriginal,
  Occurrence as OccurrenceOriginal,
  Formatted as FormattedOriginal,
  PageUrl as PageUrlOriginal,
  Status as StatusOriginal,
  StatusWithLiterals as StatusWithLiteralsOriginal,
  NotifyGuestAction as NotifyGuestActionOriginal,
  TaskContext as TaskContextOriginal,
  NotifyActionType as NotifyActionTypeOriginal,
  NotifyActionTypeWithLiterals as NotifyActionTypeWithLiteralsOriginal,
  Timing as TimingOriginal,
  TimingWithLiterals as TimingWithLiteralsOriginal,
  OrderDetails as OrderDetailsOriginal,
  TicketingOrderStatus as TicketingOrderStatusOriginal,
  TicketingOrderStatusWithLiterals as TicketingOrderStatusWithLiteralsOriginal,
  Invoice as InvoiceOriginal,
  Item as ItemOriginal,
  Money as MoneyOriginal,
  Discount as DiscountOriginal,
  DiscountItem as DiscountItemOriginal,
  DiscountItemDiscountOneOf as DiscountItemDiscountOneOfOriginal,
  CouponDiscount as CouponDiscountOriginal,
  PaidPlanDiscount as PaidPlanDiscountOriginal,
  PaidPlanDiscountDiscountOneOf as PaidPlanDiscountDiscountOneOfOriginal,
  PercentDiscount as PercentDiscountOriginal,
  Tax as TaxOriginal,
  TaxType as TaxTypeOriginal,
  TaxTypeWithLiterals as TaxTypeWithLiteralsOriginal,
  Fee as FeeOriginal,
  FeeName as FeeNameOriginal,
  FeeNameWithLiterals as FeeNameWithLiteralsOriginal,
  FeeType as FeeTypeOriginal,
  FeeTypeWithLiterals as FeeTypeWithLiteralsOriginal,
  GuestEventCanceled as GuestEventCanceledOriginal,
  GuestEventStarts as GuestEventStartsOriginal,
  GuestOrderCanceled as GuestOrderCanceledOriginal,
  GuestOrderConfirmed as GuestOrderConfirmedOriginal,
  DomainEvent as DomainEventOriginal,
  DomainEventBodyOneOf as DomainEventBodyOneOfOriginal,
  EntityCreatedEvent as EntityCreatedEventOriginal,
  RestoreInfo as RestoreInfoOriginal,
  EntityUpdatedEvent as EntityUpdatedEventOriginal,
  EntityDeletedEvent as EntityDeletedEventOriginal,
  ActionEvent as ActionEventOriginal,
  MessageEnvelope as MessageEnvelopeOriginal,
  IdentificationData as IdentificationDataOriginal,
  IdentificationDataIdOneOf as IdentificationDataIdOneOfOriginal,
  WebhookIdentityType as WebhookIdentityTypeOriginal,
  WebhookIdentityTypeWithLiterals as WebhookIdentityTypeWithLiteralsOriginal,
  AccountInfo as AccountInfoOriginal,
  QueryEventGuestsRequest as QueryEventGuestsRequestOriginal,
  QueryV2 as QueryV2Original,
  QueryV2PagingMethodOneOf as QueryV2PagingMethodOneOfOriginal,
  Sorting as SortingOriginal,
  SortOrder as SortOrderOriginal,
  SortOrderWithLiterals as SortOrderWithLiteralsOriginal,
  Paging as PagingOriginal,
  CursorPaging as CursorPagingOriginal,
  RequestedFieldsEnumRequestedFields as RequestedFieldsEnumRequestedFieldsOriginal,
  RequestedFieldsEnumRequestedFieldsWithLiterals as RequestedFieldsEnumRequestedFieldsWithLiteralsOriginal,
  QueryEventGuestsResponse as QueryEventGuestsResponseOriginal,
  PagingMetadataV2 as PagingMetadataV2Original,
  Cursors as CursorsOriginal,
  StreamEventGuestsRequest as StreamEventGuestsRequestOriginal,
  Empty as EmptyOriginal,
  SecondaryLanguagesRequest as SecondaryLanguagesRequestOriginal,
  SecondaryLanguagesResponse as SecondaryLanguagesResponseOriginal,
  Language as LanguageOriginal,
  OrderConfirmed as OrderConfirmedOriginal,
  Ticket as TicketOriginal,
  CheckIn as CheckInOriginal,
  OrderUpdated as OrderUpdatedOriginal,
  OrderDeleted as OrderDeletedOriginal,
  OrderType as OrderTypeOriginal,
  OrderTypeWithLiterals as OrderTypeWithLiteralsOriginal,
  EventDeleted as EventDeletedOriginal,
  Task as TaskOriginal,
  TaskKey as TaskKeyOriginal,
  ListGuestListPreviewsRequest as ListGuestListPreviewsRequestOriginal,
  RequestedFields as RequestedFieldsOriginal,
  RequestedFieldsWithLiterals as RequestedFieldsWithLiteralsOriginal,
  ListGuestListPreviewsResponse as ListGuestListPreviewsResponseOriginal,
  GuestListPreview as GuestListPreviewOriginal,
  GuestCount as GuestCountOriginal,
  MemberGuests as MemberGuestsOriginal,
  MemberGuest as MemberGuestOriginal,
  UpdateGuestRequest as UpdateGuestRequestOriginal,
  UpdateGuestResponse as UpdateGuestResponseOriginal,
} from './events-guests-v1-guest-guests.types.js';
